import React from 'react'
import * as Displays from 'support/displays'
import {
  ForEachModel,
  useModelKey,
  useModelValue, useValue,
  ValueToCollection
} from '@morningtrain/react-resources'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import ShiftCard from 'ui/cards/ShiftCard'
import ViewShiftSmartview from 'widgets/smartviews/shifts/ViewShiftSmartview'
import { Translation } from '@morningtrain/react-translations'
import { ShiftBadges } from 'ui/elements'
import SlotBadge from './SlotBadge'
import useActiveShift from 'support/hooks/use-active-shift'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import useShiftStatus from 'widgets/shifts/themes/calendar/use-shift-status'

export default function Slot ({ mode = 'view' }) {
  const id = useModelKey()
  const note = useModelValue('note')
  const format = 'YYYY-MM-DD HH:mm:ss'

  const [activeShift, setActiveShift] = useActiveShift()

  const { color, status } = useShiftStatus()

  return (
    <Pipeline>
      <TriggerPipelineOnClick>
        <ShiftCard
          active={activeShift === id}
          title={(<><Displays.Time name='start_at' parseFormat={format} /> - <Displays.Time name='end_at' parseFormat={format} /></>)}
          name={<Displays.Text name='user.name' defaultValue={<Translation name='generic.free_shift' defaultValue='Free shift' />} />}
          job={<Displays.Text name='user.employment_name' />}
          color={color}
          shiftState={status}
          note={note}
        >
          <ValueToCollection name='user.active_badges'>
            <ShiftBadges position='bottom-right'>
              <ForEachModel>
                <SlotBadge />
              </ForEachModel>
            </ShiftBadges>
          </ValueToCollection>
        </ShiftCard>
      </TriggerPipelineOnClick>
      <CallbackOnPipe callback={() => { setActiveShift(id) }} />
      <MountSmartviewOnPipe smartview={<ViewShiftSmartview mode={mode} />} replace={false} />
    </Pipeline>
  )
}
